/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import * as zod from "zod";

/**
 * 유효한 코드를 회원 세션 토큰으로 교환한다. 1회용 — 동시 교환은 1건만 성공.
 * @summary 연결코드 교환
 */
export const chatgptControllerExchangeLinkCodeBody = zod
  .object({
    code: zod.string().describe("세모 웹에서 발급받은 연결코드"),
  })
  .strict();

/**
 * 자연어 품목을 카탈로그 물품(itemId)과 연결한다. 무인증·무차감.
 * @summary 품목 해석
 */
export const chatgptControllerResolveItemsBody = zod
  .object({
    items: zod.array(
      zod
        .object({
          text: zod.string().describe("자연어 품목 문자열"),
          quantity: zod.number().optional().describe("수량"),
          unit: zod.string().optional().describe("단위"),
          spec: zod
            .string()
            .optional()
            .describe(
              "규격 (선택). text 에 이미 적혀 있으면 생략한다 — 있으면 후보 재순위에 함께 쓴다.",
            ),
          manufacturer: zod
            .string()
            .optional()
            .describe("제조사·브랜드 (선택). 있으면 후보의 제조사와 대조한다."),
        })
        .strict(),
    ),
  })
  .strict();

/**
 * 즉시견적 가능 여부와 카탈로그 참고 합계. 응답은 견적이 아니다(참고 시세).
 * @summary 공급 가능 확인
 */
export const chatgptControllerSupplyCheckBody = zod
  .object({
    items: zod.array(
      zod
        .object({
          itemId: zod
            .string()
            .describe("카탈로그 물품 ID (resolve_items 결과)"),
          name: zod.string().describe("품명 (표시·매칭 보조)"),
          quantity: zod.number(),
        })
        .strict(),
    ),
  })
  .strict();

/**
 * 비회원 견적요청(비공개·7일 TTL). 즉시견적 불가면 요청을 만들지 않고 NO_INSTANT_SUPPLY.
 * @summary 게스트 즉시견적 요청 생성
 */
export const chatgptControllerCreateInstantRequestHeader = zod
  .object({
    "idempotency-key": zod.string(),
  })
  .strict();

export const chatgptControllerCreateInstantRequestBodyItemsItemUnitDefault =
  "EA";
export const chatgptControllerCreateInstantRequestBodyVatIncludedDefault = true;

export const chatgptControllerCreateInstantRequestBody = zod
  .object({
    items: zod.array(
      zod
        .object({
          itemId: zod.string().describe("카탈로그 물품 ID"),
          name: zod.string(),
          quantity: zod.number(),
          unit: zod
            .string()
            .default(
              chatgptControllerCreateInstantRequestBodyItemsItemUnitDefault,
            ),
        })
        .strict(),
    ),
    deliveryRegionCode: zod
      .string()
      .optional()
      .describe("납품 지역 코드 (법정동 시도 2자리)"),
    dueDate: zod.string().optional().describe("희망 납기 (YYYY-MM-DD)"),
    vatIncluded: zod
      .boolean()
      .default(chatgptControllerCreateInstantRequestBodyVatIncludedDefault),
  })
  .strict();

/**
 * 게스트 토큰(X-Guest-Token) 또는 귀속 회원 본인. 공급사 실명·연락처는 귀속된 본인이 로그인했을 때만.
 * @summary 견적 결과 조회
 */
export const chatgptControllerGetResultsParams = zod
  .object({
    requestId: zod.coerce.string(),
  })
  .strict();

export const chatgptControllerGetResultsHeader = zod
  .object({
    "x-guest-token": zod.string(),
  })
  .strict();

/**
 * 가입/로그인 완료 시 게스트 요청을 회원에게 귀속. 요청당 1회.
 * @summary 게스트 요청 귀속
 */
export const chatgptControllerAttachParams = zod
  .object({
    requestId: zod.coerce.string(),
  })
  .strict();

export const chatgptControllerAttachBody = zod
  .object({
    guestToken: zod
      .string()
      .describe("게스트 토큰 (미리보기 URL 프래그먼트의 t)"),
  })
  .strict();

/**
 * 소유권·PDF 준비 확인 후 원자적 청구. 재다운로드 무료, chatgpt 채널만 한도 적용.
 * @summary 견적서 다운로드 청구 — 유일한 차감 지점
 */
export const chatgptControllerClaimDocumentBody = zod
  .object({
    quoteVersionId: zod.string().describe("quote_response_versions.id"),
  })
  .strict();
